<template>
  <div class="content">
    <div class="section3-left">
      <div class="s3-left-title" @click="goClick2()">
        <div class="s3-left-title-1">{{ names }}</div>
      </div>
      <div>
        <ul>
          <li
            v-for="(item, index) in newList.slice(0, 5)"
            :key="index"
            @click="goDetails1(item)"
          >
            <img src="../../static/image/home/list01.png" class="list1" /><a>{{
              item.title
            }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import lib from '../api/index';
export default {
  props: {
    names: String,
    id: Number,
    path:String
  },
  mounted() {
    this.getData();
  },
  computed:{
  },
  data() {
    return {
      newList: []
    };
  },
  methods: {
    getData() {
      lib
        .appInformationList({
          params: {
            page: 1,
            size: 10,
            classifyId: this.id
          }
        })
        .then(res => {
          // console.log(res);
          
          this.newList = res.data.records;
        });
    },
    //点击进入详情页
    goDetails1(item) {
      if (item.link == null || item.link == '') {
        this.$router
          .push({
            path: '/pageDetails',
            query: {
              id: item.id,
              name: this.names
            }
          })
          .catch(r => r);
      } else {
        location.href = item.link;
      }
    },
    //点击跳转子路由
    goClick2() {
      this.$router
        .push({
          path: this.path
        })
        .catch(r => r);
    },
    
  }
};
</script>
<style scoped>
a:hover {
  cursor: pointer;
  color: #ed0505;
}
/* .content{
    width: 100%;
    height: 100%;
    background-color: cadetblue;
} */
ul {
  margin-left: 10px;
  padding: 0;
}
ul li {
  width: 100%;
  height: 28px;
  line-height: 28px;
  margin-top: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.list1 {
  margin-right: 3%;
}
.s3-left-title {
  width: 99%;
  height: 45px;
  line-height: 45px;
  padding-left: 1%;
  /* background-color: coral; */
  border-bottom: 1px solid #015293;
  color: #015293;
  font-size: 20px;
  font-weight: bolder;
  cursor: pointer;
}
.s3-left-title-1{
  width: 30%;
  height: 100%;
  /* background-color: aquamarine; */
}
.s3-left-title-1:hover {
  /* color: rgb(236, 75, 26); */
}
.section3-left {
  width: 100%;
  height: 100%;
  /* background-color: cadetblue; */
}
.s3-left-title-spe {
  color: #999999;
  font-size: 20px;
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/Content1.vue